<template>
  <div>
    <div class="account-container">
      <div v-if="!isLayoutFlat" class="side-menu" v-bind:class="{ opened: isMobileMenuOpened }">
        <div class="nav-header">
          <h2>Account</h2>
          <button @click="toggleMenu()" v-bind:class="{ active: isMobileMenuOpened }">
            <span></span>
          </button>
        </div>

        <div class="menu-items">
          <router-link class="profile" to="/account/profile">Profile</router-link>
          <router-link class="subscription" to="/account/subscription">Subscription</router-link>
          <a href="" @click.prevent="logout()" class="logout">Logout</a>
        </div>
      </div>

      <div class="account-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Account',
  data: () => ({

  }),
  computed: {
    ...mapState(['isMobileMenuOpened', 'isLayoutFlat']),
  },
  methods: {
    toggleMenu() {
      this.$store.commit('setMobileMenuState', !this.isMobileMenuOpened);
    },
    logout() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="less" scoped>
 .account-container {
    display: flex;
    margin: 60px 0;

    .side-menu {
      width: 270px;
      flex-grow: 0;
      flex-shrink: 0;
      border-right: 1px solid #595959;

      .nav-header {
        display: flex;
        justify-content: space-between;

        h2 {
          font-size: 2rem;
          margin: 0;
          color: #fff;
        }

        button {
          display: none;
          border: none;
          background: none;
          width: 30px;
          height: 24px;
          padding: 0;
          align-items: center;
          outline: none;
          position: relative;
          align-self: center;

          span, span::before, span::after {
            position: absolute;
            display: block;
            height: 3px;
            width: 100%;
            background-color: #fff;
            transition: 0.3s;
          }

          span::before {
            content: '';
            top: -10px;
          }

          span::after {
            content: '';
            top: 10px;
          }

          &.active {
            span {
              transform: rotate(45deg);

              &::before {
                top: 0;
                transform: rotate(0);
              }

              &::after {
                top: 0;
                transform: rotate(90deg);
              }
            }
          }
        }
      }

      .menu-items {
        margin-top: 85px;

        a {
          font-size: 1.5rem;
          color: #777;
          font-weight: 400;
          padding-left: 55px;
          display: block;
          margin-bottom: 48px;
          position: relative;
          transition: 0.3s;

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 26px;
            mask-repeat: no-repeat;
            mask-position: 50% 50%;
            background-color: #ddd;
          }

          &:hover {
            color: #7ce7f2;

            &::before {
              background-color: #7ce7f2;
            }
          }

          &.profile::before {
            mask-image: url('../../assets/images/profile-icon.svg');
          }

          &.subscription::before {
            mask-image: url('../../assets/images/subscription-icon.svg');
          }

          &.logout::before {
            mask-image: url('../../assets/images/logout-icon.svg');
          }

          &.active {
            color: #fff;
            position: relative;

            &::before {
              background-color: #7ce7f2;
            }

            &::after {
              content: '';
              display: block;
              position: absolute;
              width: 3px;
              height: 100%;
              top: 0;
              right: -2px;
              background-color: #7ce7f2;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .account-content {
      padding: 0 130px;
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .account-container {
      flex-direction: column;
      margin: 40px 0;

      .side-menu {
        width: 100%;
        border-right: none;

        .nav-header {
          button {
            display: flex;
          }
        }

        .menu-items {
          margin-top: 16px;

          a {
            margin-bottom: 24px;
            font-size: 1rem;
            line-height: 24px;

            &:not(.active) {
              display: none;
            }

            &:last-child {
              margin-bottom: 24px;
            }
          }
        }

        &.opened {
          .menu-items {
            a {
              display: block;
            }
          }
        }
      }

      .account-content {
        padding: 0;
        margin-top: 24px;
      }
    }
  }
</style>
